module.exports = __webpack_public_path__ + "img/digitization.b8235453.png";